<template>
  <div class="refundRequest">

    <h1 id="formTitle">Submit a refund request</h1>
    <p>The Registry of Births, Deaths and Marriages require your bank account details to process your refund request.</p>
    <p>The bank account name needs to match the name of the person who paid for the original transaction, which in most cases is the person who applied for the service.</p>
    <p>If you qualify for a refund and the bank account details are correct, your refund will be processed in most cases, within 10 working days of receiving this refund request.</p>

    <form id="submitForm" @submit.prevent="handleSubmit">

      <ol class="questions">
        <li class="section">
          <fieldset>

            <ul class="questions">
              <li>
                <label for="applicantFirstName"> <span class="label">First name</span>
                  <abbr class="required" title="(required)">*</abbr>
                  <small class="hint">The person who applied for the original service.</small></label>
                <input id="applicantFirstName" autocomplete="given-name" v-model="form.applicantFirstName"
                       name="attributes.applicantFirstName" type="text" required
                       @invalid="showValidationMessage($event, 'First name', '')"
                       oninput="this.setCustomValidity('')"
                       class="stretchWidth" maxlength="50" @input="capitalizeFirstLetter($event,'applicantFirstName')">
              </li>
              <li>
                <label for="applicantFamilyName"> <span class="label">Family name</span>
                  <abbr class="required" title="(required)">*</abbr>
                  <small class="hint">The person who applied for the original service.</small></label>
                <input id="applicantFamilyName" autocomplete="family-name" v-model="form.applicantFamilyName"
                       name="attributes.applicantFamilyName" type="text" required="required"
                       @invalid="showValidationMessage($event, 'Family name', '')"
                       oninput="this.setCustomValidity('')"
                       class="stretchWidth" maxlength="100" @input="capitalizeFirstLetter($event,'applicantFamilyName')">
              </li>
              <li>
                <label for="applicantEmail">
                  <span class="label">Email</span>
                  <abbr class="required" title="(required)">*</abbr>
                </label>
                <input id="applicantEmail" autocomplete="email"
                       v-model="form.applicantEmail" name="attributes.applicantEmail"
                       type="email" required pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"
                       @invalid="showValidationMessage($event, 'Email', 'Please enter a valid email address')"
                       @input="clearValidationMessage($event)"
                       class="stretchWidth" maxlength="120">
              </li>
              <li>
                <label for="applicantContactMobile">
                  <span class="label">Contact number</span>
                  <abbr class="required" title="(required)">*</abbr>
                  <small class="hint">(Where we can contact you during the day time)</small>
                </label>
                <input id="applicantContactMobile" autocomplete="tel"
                       v-model="form.applicantContactMobile" name="attributes.applicantContactMobile"
                       type="tel" pattern="^[0-9]{8,15}$" required
                       @invalid="showValidationMessage($event, 'Contact number', 'Please enter a valid mobile number (8–15 digits).')"
                       @input="clearValidationMessage($event)"
                       class="stretchWidth" maxlength="15">
              </li>
              <li>
                <label for="posReferenceNumber">
                  <span class="label">POS reference</span>
                  <abbr title="(required)" class="required">*</abbr>
                  <small class="hint">(This was provided to you  in the email with the link to this online form)</small>
                </label>
                <input id="posReferenceNumber" required="required" type="tel" value="" size="30"
                       v-model="form.posReferenceNumber" name="attributes.posReferenceNumber"
                       pattern="^[0-9]{7}$"
                       @invalid="showValidationMessage($event, 'POS reference', 'POS number must be numeric and should be 7 digits')"
                       @input="clearValidationMessage($event)"
                       maxlength="7">
              </li>
            </ul>
          </fieldset>
        </li>
        <li>
          <fieldset>
            <legend id="attributes.bankAccountDetails">
              <span class="h3">Bank account details to refund to:</span>
            </legend>
           <!-- <ul class="choices">
              <label id = "refundOption" for="refundOption"> <span class="label">Choose refund option</span>
                <small class="hint">(must be an Australian bank)</small>
                <abbr class="required" title="(required)">*</abbr></label>
                <li>
                  <input id="accountDetails" v-model="form.refundOption"
                         value="accountDetails" name="attributes.refundOption" type="radio" required="">
                  <label for="accountDetails">BSB & Account Number</label>
                </li>
                <li>
                  <input id="payIdDetails" v-model="form.refundOption"
                         value="payIdDetails" name="attributes.refundOption" type="radio" required="">
                  <label for="payIdDetails">PayID</label>
                </li>
              </ul>-->
          </fieldset>
        </li>
       <!-- <li v-if="form.refundOption == 'accountDetails'">
          <fieldset>-->
            <li>
            <legend>
              <span class="label">Name of bank</span>
              <abbr class="required" title="(required)">*</abbr>
            </legend>
            <input id="refundBankName" v-model="form.refundBankName"
                   name="attributes.refundBankName" type="text" required="required"
                   @invalid="showValidationMessage($event, 'Name of bank', '')"
                   @input="clearValidationMessage($event)"
                   class="stretchWidth" maxlength="255">
            </li>
            <li>
              <legend>
                <span class="label">BSB</span>
                <abbr class="required" title="(required)">*</abbr>
              </legend>
              <input id="refundBsb" v-model="form.refundBsb"
                     name="attributes.refundBsb" type="text" required="required"
                     pattern="^[0-9]{6}$"
                     @invalid="showValidationMessage($event, 'BSB', 'BSB numbers should be numeric and have 6 digits')"
                     @input="clearValidationMessage($event)"
                     class="stretchWidth" maxlength="6">
            </li>
            <li>
              <legend>
                <span class="label">Account number</span>
                <abbr class="required" title="(required)">*</abbr>
              </legend>
              <input id="refundAccountNumber" v-model="form.refundAccountNumber"
                     name="attributes.refundAccountNumber" type="text" required="required"
                     pattern="^[0-9]{6,9}$"
                     @invalid="showValidationMessage($event, 'Account number', 'Account number should be numeric and have 6 to 9 digits')"
                     @input="clearValidationMessage($event)"
                     class="stretchWidth"  maxlength="9">
            </li>
            <li>
              <legend>
                <span class="label">Account name</span>
                <abbr class="required" title="(required)">*</abbr>
              </legend>
              <input id="refundAccountName" v-model="form.refundAccountName"
                     name="attributes.refundAccountName" type="text" required="required"
                     @invalid="showValidationMessage($event, 'Account name', '')"
                     @input="clearValidationMessage($event)"
                     class="stretchWidth" maxlength="255">
            </li>
        <!--  </fieldset>
        </li>
        <li v-if="form.refundOption == 'payIdDetails'">
          <fieldset>
            <li>
              <legend>
                <span class="label">PayID details</span>
                <abbr class="required" title="(required)">*</abbr>
                <small class="hint">(enter phone or email address linked to PayID)</small>
              </legend>
              <input id="refundPayId" v-model="form.refundPayId"
                     name="attributes.refundPayId" type="text" required="required"
                     pattern="(^[^\s@]+@[^\s@]+\.[^\s@]+$)|(^[0-9]{8,15}$)"
                     @invalid="showValidationMessage($event, 'PayID details', 'Enter PayId in proper format')"
                     @input="clearValidationMessage($event)"
                     class="stretchWidth" maxlength="255">
            </li>
            <li>
              <legend>
                <span class="label">Account name</span>
                <abbr class="required" title="(required)">*</abbr>
              </legend>
              <input id="refundAccountName" v-model="form.refundAccountName"
                     name="attributes.refundAccountName" type="text" required="required"
                     @invalid="showValidationMessage($event, 'Account name', '')"
                     @input="clearValidationMessage($event)"
                     class="stretchWidth" maxlength="255">
            </li>
          </fieldset>
        </li>-->
        <li>
          <fieldset>
            <legend>
              <span class="h3">Supporting documents</span>
              <p>
                We may request that you to provide supporting documents such as the top section of a bank statement.
              </p>
            </legend>
            <li>
              <legend>
                <span class="label">Upload supporting documents (if requested)</span>
                <small class="hint">(Files must be in JPEG, PDF or PNG format)</small>
              </legend>
              <input id="supportingDocumentation" @change="handleUpload" type="file" name="supportingDocumentation"
                     :accept="uploads.acceptedTypes">
            </li>
          </fieldset>
        </li>

        <li>
        <div class="privacyNotice">
          <strong>Privacy Statement</strong>
          <p>
            The Department of Justice, Registry of Births, Deaths, and Marriages (we/us/our) is collecting your personal information, including your name, email address, telephone number and information about your reasons for a refund.  We are collecting your information to process your refund request.  We will not use or disclose your personal information for any other purpose unless we are authorised or required under an Australian law, or court or tribunal order to do so.
          </p>
          <p>
            You can find our privacy policy <a href="https://www.publications.qld.gov.au/dataset/justice-rti-privacy/resource/cc93c01e-0abe-4696-a12f-917d36461e39" target="_blank">here</a>.  Our policy explains how you can access and amend your personal information, how to make a complaint about the way we have handled your personal information, and how your complaint will be handled.  If you have questions about how we manage your personal information, contact Right to Information and Privacy at <a :href="'mailto:'+'RTIAdministration@justice.qld.gov.au'">RTIAdministration@justice.qld.gov.au</a> or by post at GPO Box 149, BRISBANE QLD 4001.
          </p>
          <p>
            If you choose not to give us your personal information, this might impact on our ability to process your refund.  If you choose to provide us with an email address which is supported by servers outside of Australia, we will send your personal information to that email address.  This will result in your personal information being disclosed outside of Australia.  If you prefer, you can provide us with an email address supported by Australian servers to ensure your personal information remains in Australia.  An Australian server supported email address will normally end with ‘.com.au’.
          </p>
        </div>
        </li>
        <li>
          <div class="termsAndConditions">
             <strong>Terms and conditions</strong>
             <p>
               A security tool that searches the account details you’ve entered when requesting a refund on the Registry of Births, Deaths and Marriages online form against available technology.  This tool will then indicate whether the account details look right.
             </p>
          </div>
        </li>
        <li id="uploading">
          <p v-if="uploads.uploading > 0">Uploading your attachment... ({{ uploads.uploading }} remaining)</p>
          <p v-else></p>
        </li>
        <li id="inProgress">
          <p v-if="inProgress">Submitting your request...</p>
          <p v-else> </p>
        </li>
        <li>
          <fieldset>
            <ul class="actions">
              <li>
                <strong><button id="submitButton"  :disabled="inProgress">Submit refund request</button></strong>
              </li>
            </ul>
          </fieldset>
        </li>

      </ol>
    </form>
    <hr />
  </div>
</template>

<script>
import sppapi from '../../sppapi.js';

export default {
  name: 'TheRefundRequestForm',
  components: {

  },
  data: function () {
    return {
      processId: 'eftRefund',
      form: {
        applicantFirstName: '',
        applicantFamilyName: '',
        applicantEmail: '',
        applicantContactMobile: '',
        posReferenceNumber: '',
        //refundOption: '',
        refundBankName: '',
        refundBsb: '',
        refundAccountNumber: '',
        refundAccountName: '',
        //refundPayId: '',
        isExported: false
      },
      errors: {
       // refundOption:null,
        applicantEmail:'',
      },
      inProgress: false,
      uploads: {
        uploadIds: [],
        uploading: 0,
        acceptedTypes: '.jpg, .tiff, .png, .jpeg, .pdf'
      },
    }
  },

  methods: {
    removeUpload: function (event) {
      event.preventDefault()
      let targetUploadId = event.target.attributes['targetUpload'].value
      document.getElementById(targetUploadId).value = ''
      this.uploads.uploadIds = this.uploads.uploadIds.filter(uploadId => uploadId.fieldId !== targetUploadId)
      return false
    },
    uploadExists: function (fieldId) {
      return this.uploads.uploadIds.filter(uploadId => uploadId.fieldId == fieldId).length
    },
    handleUpload: function (event) {
      const selection = event.target.files[0]
      const ext = selection.name.split('.').pop();
      if (this.uploads.acceptedTypes.indexOf(ext) < 0) {
        document.getElementById(event.target.id).value = ''
        return
      }

      this.uploads.uploading++
      const reader = new FileReader()
      reader.onload = (e) => {
        sppapi.uploadFile(this, selection.name, event.srcElement.name, e.target.result)
      }
      reader.readAsDataURL(selection)
    },

    capitalizeFirstLetter(event, field) {
      let val = event.target.value;
      if (val.length > 0) {
        val = val.charAt(0).toUpperCase() + val.slice(1);
      }
      this.form[field] = val;
    },
    showValidationMessage(event, fieldLabel, patternMessage) {
      const input = event.target;
      input.setCustomValidity('');
      if (input.validity.valueMissing) {
        input.setCustomValidity(`${fieldLabel} must be completed`);
      }

      // Check for pattern mismatch (if input has 'pattern' attribute)
      else if (input.validity.patternMismatch) {
        input.setCustomValidity(patternMessage || `${fieldLabel} is invalid`);
      }
    },

    // ✅ Clear custom message when user starts typing
    clearValidationMessage(event) {
      event.target.setCustomValidity('');
    },

    handleSubmit(event) {
      const formEl = event.target;

      // stop submission if form has any invalid fields
      if (!formEl.reportValidity()) {
        return;
      }

      this.inProgress = true;

     // event.preventDefault();
      this.contactPhone = this.form.applicantContactMobile;
      this.contactEmail = this.form.applicantEmail;
      sppapi.startProcessAndCompleteTask(this);
      // Reset form and errors after successful submission
    },
  },
}

</script>

<style scoped lang="scss">
#inProgress {
  height: 1em;
}

#uploading {
  height: 1em;
}

.applicantPreferredContactEmail {
  width: 100%;
}

#supportingDocumentationFiles td {
  padding: 0 0 1.2em 0;
  background: white;
}

#supportingDocumentationFiles th {
  display: none;
}

.removeUpload {
  cursor: pointer;
}

.attachDocument {
  span {
    margin-bottom: 0em;
  }

  small {
    margin-bottom: 0.5em;
  }
}
</style>
